import { AI_EDITTING_TYPE } from '@src/constants/aiEditing';
import { COLOR } from '@src/styles/color';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  Box,
  Button,
  Fade,
  MenuItem,
  Paper,
  Popper,
  IconButton,
  Typography,
} from '@mui/material';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import ArrowDropUpRoundedIcon from '@mui/icons-material/ArrowDropUpRounded';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useClickOutside } from '@src/hooks/useClickOutSide';
import Tooltip from '@src/components/Tooltip';
import SpellcheckRoundedIcon from '@mui/icons-material/SpellcheckRounded';
import IconAwesome from '@src/assets/icons/iconawesome.svg';
import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
import WbAutoRoundedIcon from '@mui/icons-material/WbAutoRounded';
import { delay } from '@src/utils/delay';
import { useDispatch, useSelector } from 'react-redux';
import actions from '@src/redux/actions';
import {
  CountWordStyled,
  StyledBtnDropdown,
  StyledLoading,
  StyledPopupEditWord,
} from './index.style';
import { StyledIconButton } from '../NewRequest/index.style';

const AIEditor = ({ children }) => <div>{children}</div>;

const DropdownAction = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openPopper, setOpenPopper] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { typeAICheck } = useSelector((state) => state.synthesisRequest);
  const ACTIONS_DROPDOWN = {
    [AI_EDITTING_TYPE.SPELL_TEXT]: {
      title: t('spellCheck'),
      icon: <SpellcheckRoundedIcon sx={{ marginRight: '5px' }} />,
    },
    [AI_EDITTING_TYPE.GRAMMAR_TEXT]: {
      title: t('grammarCheck'),
      icon: <WbAutoRoundedIcon sx={{ marginRight: '5px' }} />,
    },
    [AI_EDITTING_TYPE.CORRECTION]: {
      title: t('correctionCheck'),
      icon: <AutoFixHighRoundedIcon sx={{ marginRight: '5px' }} />,
    },
  };
  const handleCheckWord = async (type) => {
    dispatch(actions.synthesisRequest.updateCurrentSkipWord(null));
    dispatch(actions.synthesisRequest.updateCurrentSelectedWord(null));
    dispatch(actions.synthesisRequest.updatetTypeAICheck(type));
    dispatch(actions.synthesisRequest.updateLoadingAICheck(true));
    // Delay 500ms show loading
    await delay(500);
    dispatch(actions.synthesisRequest.updateLoadingAICheck(false));
    // TODO: refactor after test
    // mock từ giả sau khi check
    dispatch(actions.synthesisRequest.updateWordsAICheck(['test']));
  };
  const refClickOutSide = useClickOutside(() => setOpenPopper(false));
  return (
    <StyledBtnDropdown>
      <Tooltip arrow title="" placement="top">
        <Box>
          <Button
            className="dropdow-button"
            ref={refClickOutSide}
            onClick={(e) => {
              setAnchorEl(e.currentTarget);
              setOpenPopper((prev) => !prev);
            }}
          >
            <Box className="button-wrapper">
              {
                ACTIONS_DROPDOWN[typeAICheck || AI_EDITTING_TYPE.SPELL_TEXT]
                  ?.icon
              }
              <Box className="button-content">
                <span>
                  {
                    ACTIONS_DROPDOWN[typeAICheck || AI_EDITTING_TYPE.SPELL_TEXT]
                      ?.title
                  }
                </span>
              </Box>
              {openPopper ? (
                <ArrowDropUpRoundedIcon
                  sx={{ fontSize: 24 }}
                  color={COLOR.indigo[80]}
                />
              ) : (
                <ArrowDropDownRoundedIcon
                  sx={{ fontSize: 24 }}
                  color={COLOR.indigo[80]}
                />
              )}
            </Box>
          </Button>
        </Box>
      </Tooltip>
      <Popper
        transition
        style={{
          zIndex: 1000,
          width: '211px',
          color: '#1E164E',
        }}
        anchorEl={anchorEl}
        open={openPopper}
        placement="top-start"
      >
        {({ TransitionProps }) => (
          <Fade
            style={{ padding: '4px 0px', marginBottom: '10px' }}
            {...TransitionProps}
            timeout={350}
          >
            <Paper value="haha">
              {Object.keys(ACTIONS_DROPDOWN).map((key) => (
                <MenuItem
                  key="handleOpenErrorReport"
                  style={{
                    color: COLOR.indigo.default,
                    fontSize: '14px',
                    height: '40px',
                    boxSizing: 'border-box',
                    padding: '10px 16px 10px 16px',
                    fontWeight: 500,
                    gap: '5px',
                  }}
                  onClick={() => handleCheckWord(key)}
                >
                  {ACTIONS_DROPDOWN[key].icon}
                  <span className="option-title">
                    {t(ACTIONS_DROPDOWN[key].title)}
                  </span>
                </MenuItem>
              ))}
            </Paper>
          </Fade>
        )}
      </Popper>
    </StyledBtnDropdown>
  );
};
const LoadingCheckWord = () => {
  const { t } = useTranslation();
  const { typeAICheck } = useSelector((state) => state.synthesisRequest);
  const title = {
    SPELL_TEXT: t('checkingForSpellingError'),
    GRAMMAR_TEXT: t('checkingForGrammarError'),
    CORRECTION: t('analyzingReadingSugguestions'),
  };

  return (
    <StyledLoading>
      <div className="blur-tts">
        <div className="content-loading">
          <img src={IconAwesome} alt="IconAwesome" />
          <span className="text-loading">{title[typeAICheck]}</span>
        </div>
      </div>
    </StyledLoading>
  );
};
const ActionsEdit = memo(({ onReplaceWord }) => {
  const { t } = useTranslation();
  const { typeAICheck, currentWordSelected } = useSelector(
    (state) => state.synthesisRequest,
  );
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState('');
  const [anchor, setAnchor] = useState(null);
  const [openPopper, setOpenPopper] = useState(false);

  const title = {
    SPELL_TEXT: t('spellCheck'),
    GRAMMAR_TEXT: t('grammarCheck'),
    CORRECTION: t('correctionCheck'),
  };

  // TODO: refactor after test
  const actionsMore = {
    SPELL_TEXT: ['Thay thế tất cả', 'Bỏ qua tất cả'],
    GRAMMAR_TEXT: ['Thay thế tất cả', 'Bỏ qua tất cả'],
    CORRECTION: ['Thay thế tất cả', 'Bỏ qua tất cả'],
  };

  const handleSkipWord = () => {
    dispatch(
      actions.synthesisRequest.updateCurrentSkipWord(currentWordSelected),
    );
    dispatch(actions.synthesisRequest.updateCurrentSelectedWord(null));
  };
  return (
    <StyledPopupEditWord
      onClick={(e) => e.stopPropagation()}
      className="editor-word"
    >
      <div className="head">
        <div className="flex-item">
          <span className="title">{title[typeAICheck]}</span>
          <Tooltip arrow title="hehe" placement="left" className="tootlip">
            <InfoOutlinedIcon
              sx={{
                width: '16px',
                height: '16px',
                color: COLOR.darkV2[32],
              }}
            />
          </Tooltip>
        </div>
        <div className="flex-item">
          <IconButton>
            <KeyboardArrowUpRoundedIcon />
          </IconButton>
          <IconButton>
            <KeyboardArrowDownRoundedIcon />
          </IconButton>
        </div>
      </div>
      <div className="content">
        <Typography
          className="word"
          dangerouslySetInnerHTML={{
            __html: t('changeTo', {
              word: currentWordSelected?.decoratedText,
            }),
          }}
        />
        <input
          type="text"
          onChange={(e) => setInputValue(e.target.value)}
          value={inputValue}
          onClick={(e) => e.stopPropagation()}
          spellcheck="false"
        />
      </div>
      <div className="actions">
        <div>
          <Button
            onClick={() => {
              if (!inputValue) return;
              onReplaceWord(inputValue || '');
            }}
            className="btn-action"
            variant="contained"
            color="primary"
          >
            {t('replace')}
          </Button>
          <Button
            onClick={handleSkipWord}
            className="btn-action outline"
            variant="text"
            color="primary"
          >
            {t('skip')}
          </Button>
        </div>
        <StyledIconButton
          height="40px"
          width="40px"
          onClick={(e) => {
            setAnchor(e.currentTarget);
            setOpenPopper((prev) => !prev);
          }}
          borderRadius="8px"
          isDisableHover
          padding="12px"
          data-id="sort-pronunciation-dict"
        >
          <Tooltip arrow title={t('otherOptions')} placement="top">
            <IconButton style={{ borderRadius: '8px' }}>
              <MoreVertOutlinedIcon className="icon-morevert" />
            </IconButton>
          </Tooltip>
          <Popper
            transition
            style={{
              zIndex: 9999,
              width: '180px',
              color: '#1E164E',
            }}
            anchorEl={anchor}
            open={openPopper}
            placement="right-start"
          >
            {({ TransitionProps }) => (
              <Fade
                style={{ padding: '4px 0px' }}
                {...TransitionProps}
                timeout={350}
              >
                <Paper>
                  {actionsMore[typeAICheck]?.map((option) => (
                    <MenuItem
                      key="recently"
                      style={{
                        color: COLOR.darkBlue,
                        fontSize: '14px',
                        height: '40px',
                        boxSizing: 'border-box',
                        padding: '10px 16px 10px 16px',
                        fontWeight: 500,
                      }}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </Paper>
              </Fade>
            )}
          </Popper>
        </StyledIconButton>
      </div>
    </StyledPopupEditWord>
  );
});

// TODO: refactor after test
const ViewAmountWordChecked = () => (
  <CountWordStyled>
    <span className="text">6 lỗi chính tả</span>
  </CountWordStyled>
);

AIEditor.DropdownAction = DropdownAction;
AIEditor.LoadingCheckWord = LoadingCheckWord;
AIEditor.ActionsEdit = ActionsEdit;
AIEditor.ViewAmountWordChecked = ViewAmountWordChecked;
export default AIEditor;
